import React from "react";
import "./Footer.css";

export default function ArabicFooter() {
  return (
    <>
      <div></div>
    </>
  );
}
